module.exports = __webpack_public_path__ + "assets/ae133da4ed055fd98c578fccfba99505.png";